





















// Importing components
import TheTownSelect from '@/components/addresses/TheTownSelect.vue';
import BaseSection from '@/ui/BaseSection.vue';
// Importing functions
import {getDiscounts} from '@/ts/discounts/get-discounts';
import {reformatDate} from '@/ts/helpers';
import {getAddressLocation} from '@/ts/deliveries/get-address-location';

export default {
    name: 'TheWelcomeDiscountsMap',
    components: {
        TheTownSelect,
        BaseSection,
    },
    props: {
        ekatte: String,
        lat: Number,
        lng: Number,
    },
    data() {
        return {
            locations: [],
            infoPosition: null,
            infoContent: null,
            infoOpened: false,
            infoCurrentKey: null,
            infoTitle: '',
            infoDiscount: '',
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35,
                },
            },
        };
    },
    mounted() {
        getDiscounts(this.ekatte).then((response: any) => {
            this.locations = response.discounts;
        });
    },
    methods: {
        getTown(value) {
            getAddressLocation(value).then((res: any) => {
                if (res.data.results.length >= 1) {
                    this.$emit('lat', res.data.results[0].geometry.location.lat);
                    this.$emit('lng', res.data.results[0].geometry.location.lng);
                }
            });
        },
        toggleInfo(item, key) {
            this.infoPosition = {
                lat: Number(item.restaurants.attributes.lat),
                lng: Number(item.restaurants.attributes.lng),
            };
            this.infoContent = 'От: ' + reformatDate(item.attributes.from) + 'г. До: '
                + reformatDate(item.attributes.to) + 'г.';
            this.infoDiscount = item.attributes.text;
            this.infoTitle = item.restaurants.attributes.name;
            if (this.infoCurrentKey === key) {
                this.infoOpened = !this.infoOpened;
            } else {
                this.infoOpened = true;
                this.infoCurrentKey = key;
            }
        },
    },
    watch: {
        ekatte(value) {
            getDiscounts(value).then((response: any) => {
                this.locations = response.discounts;
            });
        },
    },
};
